import { render, staticRenderFns } from "./layout_menu_item.vue?vue&type=template&id=1f34ae0c&scoped=true&"
import script from "./layout_menu_item.vue?vue&type=script&lang=js&"
export * from "./layout_menu_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34ae0c",
  null
  
)

export default component.exports